import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CustomPagination, NavTabs } from 'components'
import StorageService from 'utils/StorageServices/StorageServices'
import { getLRListData } from '_services/accountsServices/lrServices'
import LoadingBar from 'react-top-loading-bar';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { useParams } from 'react-router-dom';
import BootstrapTable from 'components/BootstrapTable';
import { UserContext } from 'context';
import { LrDetailModal } from 'modals';

const Lorryreceipt = () => {

    let { id } = useParams();
    const { masterData } = useContext(UserContext)
    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);

    const [showLrDetail, setShowLrDetail] = useState(false)

    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
    });

    useDocumentTitle("Lorry Receipt | T360");
    const [lrList, setLrList] = useState([]);
    const loadingBarRef = useRef(null);

    const getDataLrList = async (consignor) => {
        setLoading(true);
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                ...filter,
                company_id: StorageService.getCompanyId(),
                consignor_id: consignor ? consignor : '',
                lr_status: 0,
                select_lr_ids: [],
            };
            const res = await getLRListData(object);
            if (res?.responseCode === 200) {
                setLrList(res?.data?.lr_list);
                setTotalItems(res?.data?.total_record);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    };

    useEffect(() => {
        getDataLrList(id);
    }, [filter, id])

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const columns = [
        { header: "LR Number", accessor: "lr_number" },
        { header: "Party Name", accessor: "party_name" },
        { header: "From Station", accessor: "from_station" },
        { header: "To Station", accessor: "to_station" },
        { header: "Branch", accessor: "branch_id" },
        { header: "Invoice Number", accessor: "invoice_number" },
        { header: "Status", accessor: "status" },
    ];

    const rowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            lr_number: <>{item?.lr_number ? <div className='_tblText _lrNums' onClick={(e) => handleDetailsAction(item)}> <a className='_avPointer'> {item?.lr_number} </a> </div> : <div className='_tblText _lrNums' onClick={(e) => handleDetailsAction(item)}> <a className='_avPointer'> View </a> </div>}</>,
            party_name: <>{item?.consignor_id?.name ? item?.consignor_id?.name : '-'}</>,
            from_station: <>{item?.from_location ? item?.from_location : '-'}</>,
            to_station: <>{item?.to_location ? item?.to_location : '-'}</>,
            branch_id: <>{item?.branch_id?.branch ? item?.branch_id?.branch : '-'}</>,
            invoice_number: <>{item?.invoice_number ? item?.invoice_number : '-'}</>,
            status: <>{item?.lr_status ? <span className={masterData?.lr_status[item?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[item?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[item?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[item?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[item?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.lr_status[item?.lr_status] ? masterData?.lr_status[item?.lr_status] : ''} </span> : '-'}</>
        }));
    };

    const handleDetailsAction = (data) => {
        setShowLrDetail(data);
    }

    return (
        <div>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />

            <div className='_tabWith_topTab '>
                <BootstrapTable
                    columns={columns}
                    data={rowListData(lrList?.length > 0 ? lrList : [])}
                    isLoading={loading}
                />
                {lrList?.length > 0 &&
                    <div className='paginationFt_avt'>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter.offset}
                            onPageChange={handlePageChange}
                        />
                    </div>}
            </div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${showLrDetail ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showLrDetail ? 'visible' : 'hidden' }}
            >
                {showLrDetail
                    && (
                        <LrDetailModal
                            isOpen={showLrDetail}
                            onClose={(e) => setShowLrDetail(false)}
                            hideEditButton={true}
                        // nextModal={(e) => handleNextModal(e)}
                        />
                    )
                }
            </div>
            <div className={showLrDetail ? 'offBack_drop' : ''}></div>

        </div>
    )
}

export default Lorryreceipt